<template>
  <div class="text-xs-center">
    <v-menu :close-on-content-click="false" :nudge-width="200" offset-x>
      <v-btn slot="activator" icon>
        <v-icon>account_circle</v-icon>
      </v-btn>
      <v-card>
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <v-icon x-large>account_circle</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{user.given_name}} {{user.family_name}}</v-list-tile-title>
              <v-list-tile-sub-title>{{user.preferred_username}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="logout">Logout</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["user", "logout"]
};
</script>
